import { render, staticRenderFns } from "./ProductsTypes.vue?vue&type=template&id=28a15b2b"
import script from "./ProductsTypes.vue?vue&type=script&lang=js"
export * from "./ProductsTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a15b2b')) {
      api.createRecord('28a15b2b', component.options)
    } else {
      api.reload('28a15b2b', component.options)
    }
    module.hot.accept("./ProductsTypes.vue?vue&type=template&id=28a15b2b", function () {
      api.rerender('28a15b2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductsTypes.vue"
export default component.exports